<div
  #content
  class="content-wrapper p-text-break-word"
  [style.-webkit-line-clamp]="contentHidden ? lines : null"
  >
  {{ text }}
</div>

@if (triggerVisible) {
  <button
    pButton
    type="button"
    class="button-link p-button-link p-0 mt-2"
    icon="pi pi-chevron-{{ contentHidden ? 'down' : 'up' }}"
    label="Show {{ contentHidden ? 'more' : 'less' }}"
    (click)="toggleVisibility()"
  ></button>
}